import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { modalEdit } from '../../redux/slices/modal.slice';
import { burger } from '../../assets/img';
import styles from './index.module.scss';
import LevelForm from '../Form/LevelForm';
import TeacherForm from '../Form/TeacherForm';
import StickerForm from '../Form/StickerForm';
import StyleForm from '../Form/StyleForm';
import ChangePasswordForm from 'components/Form/ChangePasswordForm';
import SubscriptionForm from '../Form/SubscriptionForm';
import Menu from '../Menu';
import Modal from '../Modal';
import BoardForm from "../Form/BoardForm";
import RoomForm from '../Form/RoomForm';
import ModalConfirm from '../ModalConfirm';
import DaysOfWeekForm from '../Form/DaysOfWeekForm';

const Wrapper = ({ BaseComponent }) => {
    const { modal } = useSelector(state => state.modal);

    const [isOpenMenu, changeIsOpenMenu] = useState(false);
    const [isDefaultScreen, changeIsDefaultScreen] = useState(true);
    const [navCollapsed, setNavCollapsed] = useState(false);

    // When nav collapses/expands, tell FullCalendar (and any resize-aware component) to recalculate
    useEffect(() => {
        const timer = setTimeout(() => window.dispatchEvent(new Event('resize')), 220);
        return () => clearTimeout(timer);
    }, [navCollapsed]);
    const dispatch = useDispatch();
    const { chosenBoard, chosenDay } = useSelector(state => state.boards);

    const getModal = () => {
        switch (modal) {
            case null: break;
            case "Teachers":
                return <Modal entity="Teacher" >
                    <TeacherForm />
                </Modal>
            case "Styles":
                return <Modal entity="Style" >
                    <StyleForm />
                </Modal>
            case "Levels":
                return <Modal entity="Level" >
                    <LevelForm />
                </Modal>
            case "Subscriptions":
                return <Modal entity="Subscription" >
                    <SubscriptionForm />
                </Modal>
            case "Stickers":
                return <Modal entity="Class" >
                    <StickerForm />
                </Modal>
            case "Events":
                return <Modal entity="Event" title='Edit the class' >
                    <StickerForm isEvent={true} />
                </Modal>
            case "ChangePassword":
                return <Modal title="Change Password" >
                    <ChangePasswordForm />
                </Modal>
            case "BoardsEdit":
                return <Modal entity="Board" title='Edit the Schedule'>
                    <BoardForm chosenBoard={chosenBoard} />
                </Modal>
            case "BoardsAdd":
                return <Modal entity="Board" title='Add a new Schedule'  >
                    <BoardForm isAddNew />
                </Modal>
            case "Studio":
                return <Modal entity="Room" >
                    <RoomForm />
                </Modal>
            case "Day":
                return <Modal entity="Day" title={chosenDay ? 'Edit  Day' : 'Add  new day'} >
                    <DaysOfWeekForm />
                </Modal>
            case "Confirm":
                return <ModalConfirm />

            default:
                dispatch(modalEdit(null))
        }
    }

    const navWidth = navCollapsed ? '56px' : '220px';

    return (
        <div className={styles.wrapper} onClick={(e) => {
            if (e.target.getAttribute('data-menu') === 'burger') return
            changeIsOpenMenu(false)
        }}>
            {getModal()}
            <div style={{ display: 'flex', minHeight: '100vh' }}>
                {isDefaultScreen && (
                    <div
                        className={styles.navContainer}
                        style={{ width: navWidth, minWidth: navWidth }}
                    >
                        <Menu
                            isOpenMenu={isOpenMenu}
                            changeIsOpenMenu={changeIsOpenMenu}
                            navCollapsed={navCollapsed}
                            expandNav={() => setNavCollapsed(false)}
                        />
                        {/* Collapse toggle button — sits on the right edge of the nav */}
                        <button
                            onClick={() => setNavCollapsed(c => !c)}
                            className={styles.navCollapseBtn}
                            title={navCollapsed ? 'Expand navigation' : 'Collapse navigation'}
                        >
                            {navCollapsed ? '›' : '‹'}
                        </button>
                    </div>
                )}
                <div className={styles.main} style={{ flex: 1, minWidth: 0 }}>
                    {!isDefaultScreen ? null : (
                        <div className={styles.menuBurger} onClick={() => {
                            changeIsOpenMenu((isOpenMenu) => !isOpenMenu)
                        }}>
                            <img src={burger} alt='menu' data-menu='burger' />
                        </div>
                    )}
                    <BaseComponent isDefaultScreen={isDefaultScreen} changeIsDefaultScreen={changeIsDefaultScreen} />
                </div>
            </div>
        </div>
    );
}

export default Wrapper
